import React from "react";
import { DataGrid, esES } from "@mui/x-data-grid";
import SnackbarAlert from "./SnackbarAlert";
import useToken from "../useToken";
import { Tooltip } from "@mui/material";
import GetAppIcon from "@material-ui/icons/GetApp";
import { inventarioResources } from "../endpoints";
import LinearProgress from "@mui/material/LinearProgress";

class TablaPanelAuditorias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: useToken.getUser(),
      openSnack: false,
      message: null,
      severity: null,
      selectedRow: null,
      pageSize: 25
    };
  }

   getArchivoResultado = (rowData) => {
  
      let schema = "inv_" + rowData.folio;
  
      inventarioResources
        .getRutaArchivosFinales(rowData.folio)
        .then(async (response) => await response.json())
        .then((data) => {
  
          if (data.length > 0) {
  
            const link = document.createElement("a");
            let ruta = `/spool/${schema}/exportaciones/${data[0]}`;
  
            link.href = `/static${ruta}`;
  
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
  
          } else {
                this.setState({
                  openSnack:false
                  },()=>{
                  this.setState({
                      openSnack: true,
                      severity: "error",
                      message: "No hay archivos para descargar"
                  });
              })
          }
        });
    };

  render() {
     const columns = [
      { field: "folio", headerName: "Folio", flex: 1, minWidth: 100, },
      { field: "centro", headerName: "Centro", flex: 1, minWidth: 100, },
      {
        field: "mes",
        headerName: "Mes",
        flex: 1,
        minWidth: 110,
      },
      
      {
        field: "pasillos",
        headerName: "Pasillos",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "metros",
        headerName: "Metros",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },

      {
        field: "metros_auditados",
        headerName: "Metros Aud.",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_metros_auditados",
        headerName: "Metros Aud.(%)",
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
          if (params.value == null) return null;

          const valueNum = params.value;
          const valueStr = `${valueNum}%`;

          let color = "error"; // Rojo por defecto
          if (valueNum === 100) {
            color = "success"; // Verde si es perfecto
          } else if (valueNum > 50) {
            color = "warning"; // Naranja si es mayor a 50
          }

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {valueStr}
              </div>

              <LinearProgress
                variant="determinate"
                value={valueNum}
                color={color}
                sx={{
                  height: 8,
                  borderRadius: 4
                }}
              />
            </div>
          );
        }
       },
       {
        field: "metros_cumplen",
        headerName: "Metros Cumplen",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_metros_cumplen",
        headerName: "Metros Cumplen (%)",
        flex: 1,
        minWidth: 120,
      
        renderCell: (params) => {
          if (params.value == null) return null;

          const valueNum = params.value;
          const valueStr = `${valueNum}%`;

          let color = "error"; // Rojo por defecto
          if (valueNum === 100) {
            color = "success"; // Verde si es perfecto
          } else if (valueNum > 50) {
            color = "warning"; // Naranja si es mayor a 50
          }

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {valueStr}
              </div>

              <LinearProgress
                variant="determinate"
                value={valueNum}
                color={color}
                sx={{
                  height: 8,
                  borderRadius: 4
                }}
              />
            </div>
          );
        }
      },
      {
        field: "acciones",
        headerName: "Acciones",
        minWidth: 100,
        flex: 1,
        sortable: false,
        renderCell: (params) => {

        const rowData = params.row;

        return (

            <div style={{ display: "flex", gap: 8 }}>
            
            <Tooltip title="Descargar archivos finales">
                <GetAppIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => this.getArchivoResultado(rowData)}
                />
            </Tooltip>

            </div>

        );
        }
      }


    ];

    return (
      <div style={{ height: '100%', width: "100%" }}>
        <DataGrid
          rows={this.props.disponibles}
          disableColumnMenu
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rowCount={this.props.total ?? 0}
          sortingOrder={['asc', 'desc']}
          sortingMode="server" 
          onSortModelChange={this.props.onSortChange} 
          paginationMode="server"
          paginationModel={this.props.paginationModel}          
          pageSizeOptions={[10, 25, 50]}
          onPaginationModelChange={this.props.onPageChange}
          onRowClick={(params) => this.setState({ selectedRow: params.id })}
          getRowClassName={(params) => (this.state.selectedRow === params.id ? "row-selected" : "")}
          getRowId={(row) => row.folio}
        />
  
        {this.state.openSnack && (
          <SnackbarAlert
            severity={this.state.severity}
            message={this.state.message}
          />
        )}

        <style>
          {`
            .row-selected { background-color: #dbe9fc !important; }
          `}
        </style>
      </div>
    );
  }
}

export default TablaPanelAuditorias;